export default __webpack_public_path__ + "static/James-Pickering-COO-Evrchat-ef9c905e80cb55a243076e5b20a40988.png";